<template>
    <client-page className="header--light">
        <sub-visual-office
        sh="지점"
        shRe="본사"
        bg="/images/sub/visual/sv1-3-2.jpg"
        link="/introduction/office"
        linkText="본사가 궁금하다면?">
            <p>
                고객사에 대한 깊은 이해를 바탕으로 효과적이고 전략적인 세일즈/캠페인을 기획 및 실행합니다. 또한 체계적인 교육을 통해 전문
                브랜드 홍보대사 & 펀드레이저를 양성합니다.
            </p>
        </sub-visual-office>

        <section class="section pt-0">
            <v-container>
                <v-row justify="center">
                    <v-col cols="12" md="6" lg="4">
                        <image-on
                        bg="/images/sub/about/branch/s1-img1.jpg"
                        bgOn="/images/sub/about/branch/s1-img1-on.jpg"
                        tit="지점장 & 부지점장">

                            <div class="mb-8 mb-xl-16">
                                <num-content
                                num="01"
                                space="pl-8 pl-lg-12">
                                    <p class="page-text--sm">
                                        지점 운영 및 관리
                                    </p>
                                </num-content>
                            </div>

                            <div class="mb-8 mb-xl-16">
                                <num-content
                                num="02"
                                space="pl-8 pl-lg-12">
                                    <p class="page-text--sm">
                                        캠페인 기획 및 컨설팅
                                    </p>
                                </num-content>
                            </div>

                            <div>
                                <num-content
                                num="03"
                                space="pl-8 pl-lg-12">
                                    <p class="page-text--sm">
                                        브랜드 홍보대사 & 펀드레이저 양성
                                    </p>
                                </num-content>
                            </div>

                        </image-on>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <image-on
                        bg="/images/sub/about/branch/s1-img2.jpg"
                        bgOn="/images/sub/about/branch/s1-img2-on.jpg"
                        tit="브랜드 홍보대사 & 펀드레이저"
                        titWidth="w-xl-50">

                            <div class="mb-8 mb-xl-16">
                                <num-content
                                num="01"
                                space="pl-8 pl-lg-12">
                                    <p class="page-text--sm">
                                        캠페인 활동
                                    </p>
                                </num-content>
                            </div>

                            <div class="mb-8 mb-xl-16">
                                <num-content
                                num="02"
                                space="pl-8 pl-lg-12">
                                    <p class="page-text--sm">
                                        고객사 브랜드의 가치 전달
                                    </p>
                                </num-content>
                            </div>

                            <div>
                                <num-content
                                num="03"
                                space="pl-8 pl-lg-12">
                                    <p class="page-text--sm">
                                        세일즈 및 홍보 대행 (제품 또는 서비스)
                                    </p>
                                </num-content>
                            </div>

                        </image-on>
                    </v-col>
                    <v-col cols="12" md="6" lg="4">
                        <image-on
                        bg="/images/sub/about/branch/s1-img3.jpg"
                        bgOn="/images/sub/about/branch/s1-img3-on.jpg"
                        tit="어드민">

                            <div class="mb-8 mb-xl-16">
                                <num-content
                                num="01"
                                space="pl-8 pl-lg-12">
                                    <p class="page-text--sm">
                                        사무직 (지점 근무)
                                    </p>
                                </num-content>
                            </div>

                            <div class="mb-8 mb-xl-16">
                                <num-content
                                num="02"
                                space="pl-8 pl-lg-12">
                                    <p class="page-text--sm">
                                        지점 채용 관리
                                    </p>
                                </num-content>
                            </div>

                            <div>
                                <num-content
                                num="03"
                                space="pl-8 pl-lg-12">
                                    <p class="page-text--sm">
                                        사무 행정 및 총무 업무
                                    </p>
                                </num-content>
                            </div>

                        </image-on>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="section bg-grey">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">
                        무한한 성장이 가능한 <br class="d-none d-md-block">
                        브랜드 홍보대사 & 펀드레이저
                    </h3>
                    <p class="tit-txt">
                        세일즈웍스는 성과에 대한 인정 및 보상, 경력 개발을 위한 교육의 기회를 제공합니다. <br>
                        다양한 지원을 바탕으로 커리어를 확장하여 팀을 관리하고, 더 나아가 지점을 운영할 수 있습니다.
                    </p>
                </div>

                <v-divider></v-divider>

                <section class="section--sm">
                    <h5 class="tit-txt font-weight-bold mb-30 mb-lg-24">
                        Stage 1<span class="txt-line mx-6 mx-lg-10"></span><span class="color-point">첫 발을 내딛다</span>
                    </h5>
                    <v-img src="/images/sub/about/branch/s2-img1.jpg" class="w-100 mb-30 mb-lg-54"></v-img>
                    <div class="px-md-30 px-lg-40">
                        <div class="mb-12 mb-lg-24">
                            <num-content
                            num="01"
                            space="pl-8 pl-lg-16">
                                <h5 class="tit-txt font-weight-bold mb-2">
                                    체계적인 교육
                                </h5>
                                <p class="page-text--sm color-grey-7">
                                    국내외 워크숍, 온라인 교육을 통해 고객사, 커뮤니케이션 스킬, 리더십 등 전문적인 교육을 받습니다.
                                </p>
                            </num-content>
                        </div>
                        <div class="mb-12 mb-lg-24">
                            <num-content
                            num="02"
                            space="pl-8 pl-lg-16">
                                <h5 class="tit-txt font-weight-bold mb-2">
                                    세일즈/캠페인 활동
                                </h5>
                                <p class="page-text--sm color-grey-7">
                                    고객사의 얼굴이 되어 브랜드의 가치를 전달합니다.
                                </p>
                            </num-content>
                        </div>
                        <div>
                            <num-content
                            num="03"
                            space="pl-8 pl-lg-16">
                                <h5 class="tit-txt font-weight-bold mb-2">
                                    역량 강화
                                </h5>
                                <p class="page-text--sm color-grey-7">
                                    전문가의 피드백을 통해 나에게 맞는 목표를 설정하고 계획을 수립합니다.
                                </p>
                            </num-content>
                        </div>
                    </div>
                </section>

                <v-divider></v-divider>

                <section class="section--sm">
                    <h5 class="tit-txt font-weight-bold mb-30 mb-lg-24">
                        Stage 2<span class="txt-line mx-6 mx-lg-10"></span><span class="color-point">팀을 이끌다</span>
                    </h5>
                    <v-img src="/images/sub/about/branch/s2-img2.jpg" class="w-100 mb-30 mb-lg-54"></v-img>
                    <div class="px-md-30 px-lg-40">
                        <div class="mb-12 mb-lg-24">
                            <num-content
                            num="01"
                            space="pl-8 pl-lg-16">
                                <h5 class="tit-txt font-weight-bold mb-2">
                                    팀 운영
                                </h5>
                                <p class="page-text--sm color-grey-7">
                                    팀원들과 소통을 통해 목표를 설정하고, 팀원들이 성장할 수 있도록 전략을 수립하여 팀을 성장시킵니다.
                                </p>
                            </num-content>
                        </div>
                        <div class="mb-12 mb-lg-24">
                            <num-content
                            num="02"
                            space="pl-8 pl-lg-16">
                                <h5 class="tit-txt font-weight-bold mb-2">
                                    세일즈/캠페인 활동
                                </h5>
                                <p class="page-text--sm color-grey-7">
                                    멘토가 되어 캠페인 활동을 교육하고 지원합니다.
                                </p>
                            </num-content>
                        </div>
                        <div>
                            <num-content
                            num="03"
                            space="pl-8 pl-lg-16">
                                <h5 class="tit-txt font-weight-bold mb-2">
                                    역량 강화
                                </h5>
                                <p class="page-text--sm color-grey-7">
                                    지점장과 소통하며 팀의 발전방향을 논의하며 리더십을 강화합니다.
                                </p>
                            </num-content>
                        </div>
                    </div>
                </section>

                <v-divider></v-divider>

                <section class="section--sm pb-0">
                    <h5 class="tit-txt font-weight-bold mb-30 mb-lg-24">
                        Stage 3<span class="txt-line mx-6 mx-lg-10"></span><span class="color-point">지점을 운영하다</span>
                    </h5>
                    <v-img src="/images/sub/about/branch/s2-img3.jpg" class="w-100 mb-30 mb-lg-54"></v-img>
                    <div class="px-md-30 px-lg-40">
                        <div class="mb-12 mb-lg-24">
                            <num-content
                            num="01"
                            space="pl-8 pl-lg-16">
                                <h5 class="tit-txt font-weight-bold mb-2">
                                    지점 운영
                                </h5>
                                <p class="page-text--sm color-grey-7">
                                    세일즈웍스의 비즈니스 운영 방식을 배우고 지점을 효율적으로 관리합니다.
                                </p>
                            </num-content>
                        </div>
                        <div class="mb-12 mb-lg-24">
                            <num-content
                            num="02"
                            space="pl-8 pl-lg-16">
                                <h5 class="tit-txt font-weight-bold mb-2">
                                    인재 양성
                                </h5>
                                <p class="page-text--sm color-grey-7">
                                    인재를 발굴하고 전문적인 교육 과정을 개발 및 수행하여 전문가를 양성합니다.
                                </p>
                            </num-content>
                        </div>
                        <div>
                            <num-content
                            num="03"
                            space="pl-8 pl-lg-16">
                                <h5 class="tit-txt font-weight-bold mb-2">
                                    역량 강화
                                </h5>
                                <p class="page-text--sm color-grey-7">
                                    해외 지사와 소통하며 글로벌 네트워크를 구축하고, 전문 경영인으로 성장하기 위한 교육을 받습니다.
                                </p>
                            </num-content>
                        </div>
                    </div>
                </section>
            </v-container>
        </section>

        <section class="section">
            <v-container>
                <div class="tit-wrap mb-lg-40">
                    <h3 class="tit font-weight-bold">
                        전국 지점 위치
                    </h3>
                    <p class="tit-txt">
                        전국 주요 도시에 위치한 지점을 바탕으로 <br class="d-none d-md-block">
                        전국적인 캠페인 활동을 진행하고 있습니다.
                    </p>
                    <!-- <p class="page-text--sm mt-4 mt-lg-8 color-grey-c7">
                        *2022년 12월 기준
                    </p> -->
                </div>
                <div data-aos="zoom-in-up">
                    <v-img src="/images/sub/about/branch/s3-img.jpg" max-width="1000" contain class="mx-auto mb-30 mb-lg-70"></v-img>
                    <div class="d-flex justify-center">
                        <arrow-btn tit="지점 상세 정보" color="primary" link="/location" type="to"></arrow-btn>
                    </div>
                </div>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisualOffice from "@/components/client/sub/sub-visual-office.vue";
import ImageOn from "@/components/client/sub/sub-image-on.vue";
import NumContent from "@/components/client/sub/sub-num-content.vue";
import ArrowBtn from "@/components/client/sub/arrow-btn.vue";
export default {
    components: {
        ClientPage,
        SubVisualOffice,
        ImageOn,
        NumContent,
        ArrowBtn,
    },
};
</script>

